import { createSelector } from '@ngrx/store';

import { NtyUniversalCreateSegmentConfig } from '@ninety/mobile/platform/api';
import {
  CurrentUserSelectors,
  CompanyUserSelectors,
  featureFlagSelectors,
  FeatureFlagKeys,
  LanguageSelectors,
  selectFeatureEnabled,
  selectQuarterlyDiscussionsAvailable,
  Scopes,
} from '@ninety/mobile/platform/state';

export const selectCanViewCompanyAssessments = createSelector(
  CurrentUserSelectors.selectUser,
  CurrentUserSelectors.selectUserIsAdminOrOwner,
  CompanyUserSelectors.selectCurrentCompanySltTeamId,
  featureFlagSelectors.selectAll,
  (user, isAdminOrOwner, sltTeamId, ff) => {
    const isAdminOrSLT = isAdminOrOwner || user?.teams?.some(t => t.teamId === sltTeamId);
    return isAdminOrSLT && ff?.[FeatureFlagKeys.enableAssessments];
  }
);

/**
 * Whether the create sheet offers Review.
 *
 * Entitlement and setting collapse to one outcome here — a create sheet has nowhere to host an
 * upgrade prompt. They stay distinct on the Reviews tab, which is gated on the setting alone.
 */
export const selectCanCreateDiscussion = createSelector(
  selectFeatureEnabled(Scopes.oneOnOne),
  selectQuarterlyDiscussionsAvailable,
  (hasDiscussionAccess, quarterlyDiscussionsAvailable): boolean => hasDiscussionAccess && quarterlyDiscussionsAvailable
);

export const selectUniversalCreateConfig = createSelector(
  LanguageSelectors.language,
  selectCanViewCompanyAssessments,
  selectCanCreateDiscussion,
  (companyLang, canViewCompanyAssessments, canCreateDiscussion): NtyUniversalCreateSegmentConfig[] => {
    return [
      { feature: 'todo', displayText: companyLang.todo.item, hideSegment: false },
      { feature: 'issue', displayText: companyLang.issue.item, hideSegment: false },
      { feature: 'headline', displayText: companyLang.headline.item, hideSegment: false },
      { feature: 'rock', displayText: companyLang.rock.item, hideSegment: false },
      { feature: 'discussion', displayText: companyLang.feedback.item, hideSegment: !canCreateDiscussion },
      { feature: 'assessment', displayText: companyLang.survey.item, hideSegment: !canViewCompanyAssessments },
    ];
  }
);
